/**
 * Device detection utilities
 */

/**
 * Detects if the current device is mobile
 * Used for determining payment flow (callback vs redirect)
 */
export const isMobile = (): boolean => {
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

/**
 * Detects if the current device is iOS
 */
export const isIOS = (): boolean => {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
};

/**
 * Detects if the current device is Android
 */
export const isAndroid = (): boolean => {
  return /Android/i.test(navigator.userAgent);
};
